import type { ReactNode } from "react";
import { Card } from "@/components/ui/Card";
import { SECTION_LABEL_CLASS } from "@/components/ui/SectionLabel";

interface SettingsSectionProps {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
}

/**
 * A titled group of rows.
 *
 * Shared because gaia-app's settings and account pages each defined their own copy of this
 * chrome - the same section, card and row rules in two stylesheets.
 */
export function SettingsSection({ title, icon, children }: SettingsSectionProps) {
  return (
    <section className="flex flex-col gap-3">
      <h2 className={`flex items-center gap-2 ${SECTION_LABEL_CLASS}`}>
        {icon}
        {title}
      </h2>
      <Card className="overflow-hidden">{children}</Card>
    </section>
  );
}
